import { useMemo } from 'react'
import styled from '@emotion/styled'
import Text from '../../components/common/Text'
import Card from '../../components/common/Card'
import { mobile } from '../../utils/responsive-helper'
import Image from '../../components/common/Image'
import coinIconBorder from '../../assets/images/group-16.svg'
import coinIcon from '../../assets/images/icons-coin-green-32-px.svg'
import { BORDER, FONT_LIGHT_GRAY, PRIMARY } from '../../constant/colors'
import { EClaimItem } from '../../services/e-claim/e-claim-types'
import { useGetUserCoin } from '../../services/user/user-query'
import receiptIcon from '../../assets/images/icons-slip-48-px.svg'
import { numberWithCommas } from '../../utils/helper'

const TitleContainer = styled.div`
  margin-top: 32px;
  margin-bottom: 24px;
  width: 100%;
  display: flex;
  justify-content: center;
`

const DetailContainer = styled.div`
  /* border: 1px solid #000000; */
  margin-left: 0px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 24px;
  justify-content: flex-start;
  margin-bottom: 15px;

  ${mobile} {
    grid-template-columns: 1fr;
    justify-content: center;
  }
`

const DetailCard = styled(Card)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 133px;
  padding-top: 16px;
  padding-bottom: 16px;
`

const Divider = styled.div`
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: ${BORDER};
  width: 100%;
  height: 1px;
`
const SectionTitleContainer = styled.div`
  margin-top: 24px;
  margin-bottom: 16px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
`

const RequireDocumentCard = styled(Card)`
  height: 112px;
  margin-bottom: 16px;

  ${mobile} {
    height: 224px;
  }
`

/* const RequireDocumentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 24px;
  justify-content: center;
  margin-bottom: 15px;
  align-items: center;
  height: 100%;

  ${mobile} {
    grid-template-columns: 1fr;
  }
` */

type EClaimInfoProps = {
  eClaimItem?: EClaimItem
  hideDetail?: boolean
}

const EClaimInfo = (props: EClaimInfoProps) => {
  const { eClaimItem, hideDetail = false } = props

  const { data: userCoin = 0 } = useGetUserCoin()

  const userCoinFormated = useMemo(() => {
    return userCoin.toLocaleString(undefined, { maximumFractionDigits: 2 })
  }, [userCoin])

  return (
    <>
      <TitleContainer>
        <Text type="Bold" size={28}>
          เบิกสวัสดิการ
        </Text>
      </TitleContainer>
      <DetailContainer>
        <DetailCard>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Image src={coinIcon} />
              &nbsp;
              <Text size={20} type={'Bold'} color={PRIMARY}>{`${userCoinFormated}`}</Text>
              &nbsp;
              <Text type={'Bold'}>{`คะแนน`}</Text>
            </div>
            {/* <Text type={'Bold'}>{`(คิดเป็นเงิน ${userCoinFormated} บาท)`}</Text> */}
          </div>
        </DetailCard>
        <DetailCard>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-around',
              alignItems: 'center',
              height: '100%',
              width: '100%',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                marginLeft: '16px',
              }}
            >
              {/* Todo change icon by api */}
              <Image src={coinIcon} />
              &nbsp;&nbsp;&nbsp;
              <Text size={16} type={'Bold'}>
                {eClaimItem?.claimName}
              </Text>
            </div>
            <Divider />
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Image src={coinIconBorder} />
              &nbsp;&nbsp;&nbsp;
              <Text size={16}>
                {eClaimItem?.availableAmount
                  ? numberWithCommas(Number(eClaimItem?.availableAmount))
                  : 0}
              </Text>
            </div>
          </div>
        </DetailCard>
      </DetailContainer>
      {!hideDetail && (
        <Text>
          <strong>เงื่อนไขการใช้สวัสดิการนี้:</strong> {eClaimItem?.claimDetail}
        </Text>
      )}
      {/* {hideDetail === false && (
        <>
          <SectionTitleContainer>
            <Text type="Bold" size={26}>
              เอกสารที่ต้องใช้ในการขอใช้สวัสดิการนี้
            </Text>
          </SectionTitleContainer>
          <RequireDocumentCard>
            <div
              style={{
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 16,
              }}
            >
              <Image src={receiptIcon} />
              &nbsp;&nbsp;&nbsp;
              <Text size={24} type="Bold">
                แนบเอกสารประกอบการเบิก เช่นใบเสร็จ ใบรับรองเเพทย์ หรือเอกสารอื่นๆ ที่เกี่ยวข้อง
              </Text>
            </div>
          </RequireDocumentCard>
          <Text color={FONT_LIGHT_GRAY}>
            หมายเหตุ: ยอดเงินที่คุณจะได้รับ จะถูกบริษัทหักตามภาษีเงินได้ของคุณ ก่อนจ่ายจริง
          </Text>
        </>
      )} */}
    </>
  )
}

export default EClaimInfo
